<div class="p-30 full-grow-no-shrink-no-basis" *ngIf="apiKey===null">
    <div *ngIf="arrangements">
        <mat-label>Select an arrangement</mat-label>
        <mat-select>
            <mat-option *ngFor="let arrangement of arrangements" [value]="arrangement.id">
                {{arrangement.caseId}}
            </mat-option>
        </mat-select>
    </div>
    <particle-entity-chart-entity-selector [filterId]="filterId" [filterTemplateId]="filterTemplateId"
                                           [invalidateSubject]="invalidateSubject">
    </particle-entity-chart-entity-selector>
</div>
<div class="m-lr-30 m-b-30 flex flex-col justify-start items-start full-grow-no-shrink-no-basis" *ngIf="apiKey!==null">

    <div class="w-p-47 flex flex-row">
        <mat-form-field *ngIf="arrangements" appearance="outline" class="m-r-20 full-grow-no-shrink-no-basis"
                        style="margin-bottom:0!important">
            <mat-label>Assign case for Consolidated Transaction</mat-label>
            <mat-select (selectionChange)="onSelectCase($event)">
                <mat-option *ngFor="let arrangement of arrangements" [value]="arrangement">
                    {{arrangement.caseId}}
                </mat-option>
                <mat-option>None</mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field *ngIf="currencies" appearance="outline" class="full-grow-no-shrink-no-basis"
                        style="margin-bottom:0!important">
            <mat-label>Select Currency for Consolidated Transaction</mat-label>
            <mat-select (selectionChange)="onSelectCurrency($event)">
                <mat-option *ngFor="let currency of currencies" [value]="currency">
                    {{currency.displayName}}
                </mat-option>
                <mat-option>None</mat-option>
            </mat-select>
        </mat-form-field>
    </div>


    <particle-entity-selector class="full-grow-no-shrink-no-basis" [filterId]="filterId"
                              [filterTemplateId]="filterTemplateId"
                              [invalidateSubject]="invalidateSubject"
                              [endpointName]="apiKey"
                              [itemUrlIndex]="itemUrlIndex"
                              [leftSourceType]="leftSourceType"
                              [rightSourceType]="rightSourceType"
                              [selectionKey]="selectionKey"
                              [input]="inputs"
                              [isAppliedToggle]="isAppliedToggle"
                              (leftGridCellValueChange)="onGridCellValueChanged($event)"
                              (rightGridCellValueChange)="onGridCellValueChanged($event)"
    >
    </particle-entity-selector>
</div>
